
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The schema's entry-point for mutations.`}</p>
    <p>{`This acts as the public, top-level API from which all mutation queries must start.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;